import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import { selectFilteredReportCount } from '../../selectors/reportsSelector';
// @ts-expect-error Untyped import
import { getReports } from '../../actions/reportsActions';
import { useCallback, useMemo } from 'react';
// @ts-expect-error Untyped import
import { selectedRowsActions } from '../../redux/selectedRows';
// @ts-expect-error Untyped import
import { ReportingTracker } from '../../lib/usageTracker';
// @ts-expect-error Untyped import
import { selectQueryFilters } from '../../selectors/reportsSelector';
// @ts-expect-error Untyped import
import { BulkSetReportBusinessUnitButton } from 'reporting-action-components/reportingActions/setReportBusinessUnit/BulkSetReportBusinessUnitButton';
import { jsx as _jsx } from "react/jsx-runtime";
const BulkSetBusinessUnitAction = ({
  selectedRows,
  selectedEverything
}) => {
  const filters = useSelector(selectQueryFilters);
  const dispatch = useDispatch();
  const reports = useMemo(() => selectedEverything ? [] : selectedRows.toArray(), [selectedEverything, selectedRows]);
  const filteredReportCount = useSelector(selectFilteredReportCount);
  const onSetBusinessUnitSuccess = useCallback(() => {
    dispatch(getReports());
    dispatch(selectedRowsActions.clearSelectedRows());
  }, [dispatch]);
  return /*#__PURE__*/_jsx(BulkSetReportBusinessUnitButton, {
    filteredAssetCount: filteredReportCount,
    filters: filters,
    onSetBusinessUnitSuccess: onSetBusinessUnitSuccess,
    usageTracker: ReportingTracker,
    assets: reports
  });
};
export default BulkSetBusinessUnitAction;